/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PrincipalList01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const principalList01ResetTimestamp = (
  state,
  { currentPage, sorts, filters, pageSize }
) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  selectedResources: INITIAL_STATE.selectedResources,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const principalList01FetchPrincipalList01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const principalList01FetchPrincipalList01Success = (
  state,
  { resources, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  resources,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const principalList01AddSelectedResources = (state, { selectedResources }) => {
  const selectIds = state.selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: [
      ...state.selectedResources,
      ...selectedResources.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const principalList01RemoveSelectedResources = (state, { selectedResources }) => {
  const selectIds = selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: state.selectedResources.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const principalList01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PrincipalList01Types.PRINCIPAL_LIST01_RESET_TIMESTAMP]: principalList01ResetTimestamp,
  [PrincipalList01Types.PRINCIPAL_LIST01_FETCH_PRINCIPAL_LIST01_LOADING]: principalList01FetchPrincipalList01Loading,
  [PrincipalList01Types.PRINCIPAL_LIST01_FETCH_PRINCIPAL_LIST01_SUCCESS]: principalList01FetchPrincipalList01Success,
  [PrincipalList01Types.PRINCIPAL_LIST01_ADD_SELECTED_RESOURCES]: principalList01AddSelectedResources,
  [PrincipalList01Types.PRINCIPAL_LIST01_REMOVE_SELECTED_RESOURCES]: principalList01RemoveSelectedResources,
  [PrincipalList01Types.PRINCIPAL_LIST01_SET_WORKSPACE_VISIBLE]: principalList01SetWorkspaceVisible
});
